const isPointInsideCircle = (x: number, y: number, cx: number, cy: number, r: number) => {
  // Calculate the distance between the point and the circle's center
  const distance = Math.sqrt(Math.pow(x - cx, 2) + Math.pow(y - cy, 2));

  // If the distance is less than the radius, the point is inside the circle
  return distance < r;
};

export default isPointInsideCircle;
